"use strict";

class NewsletterReminder extends HTMLElement {
  constructor() {
    super();
    this.closeBtn = this.querySelector("[data-close-button]");
    this.popupTrigger = this.querySelector("[data-message]");

    this.id = this.dataset.sectionId;
    this.newsletterId = `NewsletterPopup-${this.id}`;
    this.cookie = Cookies.get(`newsletter-${this.id}`);
    this.cookieName = `newsletter-${this.id}`;
    this.secondsBeforeShow = this.dataset.delaySeconds;
    this.expiry = parseInt(this.dataset.delayDays);
    this.modal = new theme.Modals(
      `NewsletterPopup-${this.newsletterId}`,
      "newsletter-popup-modal",
    );

    this.init();
  }

  init() {
    document.addEventListener("shopify:block:select", (evt) => {
      if (evt.detail.sectionId === this.id) {
        this.show(0, true);
      }
    });

    document.addEventListener("shopify:block:deselect", (evt) => {
      if (evt.detail.sectionId === this.id) {
        this.hide();
      }
    });

    document.addEventListener(`modalOpen.${this.newsletterId}`, () =>
      this.hide(),
    );
    document.addEventListener(`modalClose.${this.newsletterId}`, () =>
      this.show(),
    );

    this.closeBtn.addEventListener("click", () => {
      this.hide();
      Cookies.set(this.cookieName, "opened", {
        path: "/",
        expires: this.expiry,
      });
    });

    this.popupTrigger.addEventListener("click", () => {
      const reminderOpen = new CustomEvent("reminder:openNewsletter", {
        bubbles: true,
      });
      this.dispatchEvent(reminderOpen);

      this.hide();
    });
  }

  show(time = this.secondsBeforeShow, forceOpen = false) {
    if (!sessionStorage.getItem("newsletterAppeared") === true || forceOpen) {
      setTimeout(() => {
        this.dataset.enabled = "true";
        if (!forceOpen) sessionStorage.setItem("newsletterAppeared", true);
      }, time * 1000);
    }
  }

  hide() {
    this.dataset.enabled = "false";
  }
}

customElements.define("newsletter-reminder", NewsletterReminder);

theme.customerTemplates = function () {
  checkUrlHash();
  initEventListeners();
  resetPasswordSuccess();
  customerAddressForm();

  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === "#recover") {
      toggleRecoverPasswordForm();
    }
  }

  function toggleRecoverPasswordForm() {
    var passwordForm = document
      .getElementById("RecoverPasswordForm")
      .classList.toggle("hide");
    var loginForm = document
      .getElementById("CustomerLoginForm")
      .classList.toggle("hide");
  }

  function initEventListeners() {
    // Show reset password form
    var recoverForm = document.getElementById("RecoverPassword");
    if (recoverForm) {
      recoverForm.addEventListener("click", function (evt) {
        evt.preventDefault();
        toggleRecoverPasswordForm();
      });
    }

    // Hide reset password form
    var hideRecoverPassword = document.getElementById(
      "HideRecoverPasswordLink",
    );
    if (hideRecoverPassword) {
      hideRecoverPassword.addEventListener("click", function (evt) {
        evt.preventDefault();
        toggleRecoverPasswordForm();
      });
    }
  }

  function resetPasswordSuccess() {
    var formState = document.querySelector(".reset-password-success");

    // check if reset password form was successfully submitted
    if (!formState) {
      return;
    }

    // show success message
    document.getElementById("ResetSuccess").classList.remove("hide");
  }

  function customerAddressForm() {
    var newAddressForm = document.getElementById("AddressNewForm");
    var addressForms = document.querySelectorAll(".js-address-form");

    if (!newAddressForm || !addressForms.length) {
      return;
    }

    // Country/province selector can take a short time to load
    setTimeout(function () {
      document.querySelectorAll(".js-address-country").forEach((el) => {
        var countryId = el.dataset.countryId;
        var provinceId = el.dataset.provinceId;
        var provinceContainerId = el.dataset.provinceContainerId;

        new Shopify.CountryProvinceSelector(countryId, provinceId, {
          hideElement: provinceContainerId,
        });
      });
    }, 1000);

    // Toggle new/edit address forms
    document.querySelectorAll(".address-new-toggle").forEach((el) => {
      el.addEventListener("click", function () {
        newAddressForm.classList.toggle("hide");
      });
    });

    document.querySelectorAll(".address-edit-toggle").forEach((el) => {
      el.addEventListener("click", function (evt) {
        var formId = evt.currentTarget.dataset.formId;
        document
          .getElementById("EditAddress_" + formId)
          .classList.toggle("hide");
      });
    });

    document.querySelectorAll(".address-delete").forEach((el) => {
      el.addEventListener("click", function (evt) {
        var formId = evt.currentTarget.dataset.formId;
        var confirmMessage = evt.currentTarget.dataset.confirmMessage;

        if (
          confirm(
            confirmMessage || "Are you sure you wish to delete this address?",
          )
        ) {
          if (Shopify) {
            Shopify.postLink("/account/addresses/" + formId, {
              parameters: { _method: "delete" },
            });
          }
        }
      });
    });
  }
};

theme.Maps = (function () {
  var config = {
    zoom: 14,
  };
  var apiStatus = null;
  var mapsToLoad = [];

  var errors = {};

  var selectors = {
    section: '[data-section-type="map"]',
    map: "[data-map]",
    mapOverlay: ".map-section__overlay",
  };

  // Global function called by Google on auth errors.
  // Show an auto error message on all map instances.
  window.gm_authFailure = function () {
    if (!Shopify.designMode) {
      return;
    }

    document.querySelectorAll(selectors.section).forEach((section) => {
      section.classList.add("map-section--load-error");
    });

    document.querySelectorAll(selectors.map).forEach((map) => {
      map.parentNode.removeChild(map);
    });

    window.mapError(theme.strings.authError);
  };

  window.mapError = function (error) {
    var message = document.createElement("div");
    message.classList.add("map-section__error", "errors", "text-center");
    message.innerHTML = error;
    document.querySelectorAll(selectors.mapOverlay).forEach((overlay) => {
      overlay.parentNode.prepend(message);
    });
    document.querySelectorAll(".map-section__link").forEach((link) => {
      link.classList.add("hide");
    });
  };

  function Map(container) {
    this.container = container;
    this.sectionId = this.container.getAttribute("data-section-id");
    this.namespace = ".map-" + this.sectionId;
    this.map = container.querySelector(selectors.map);
    this.key = this.map.dataset.apiKey;

    errors = {
      addressNoResults: theme.strings.addressNoResults,
      addressQueryLimit: theme.strings.addressQueryLimit,
      addressError: theme.strings.addressError,
      authError: theme.strings.authError,
    };

    if (!this.key) {
      return;
    }

    theme.initWhenVisible({
      element: this.container,
      callback: this.prepMapApi.bind(this),
      threshold: 20,
    });
  }

  // API has loaded, load all Map instances in queue
  function initAllMaps() {
    mapsToLoad.forEach((instance) => {
      instance.createMap();
    });
  }

  function geolocate(map) {
    var geocoder = new google.maps.Geocoder();

    if (!map) {
      return;
    }

    var address = map.dataset.addressSetting;

    var deferred = new Promise((resolve, reject) => {
      geocoder.geocode({ address: address }, function (results, status) {
        if (status !== google.maps.GeocoderStatus.OK) {
          reject(status);
        }
        resolve(results);
      });
    });

    return deferred;
  }

  Map.prototype = Object.assign({}, Map.prototype, {
    prepMapApi: function () {
      if (apiStatus === "loaded") {
        this.createMap();
      } else {
        mapsToLoad.push(this);

        if (apiStatus !== "loading") {
          apiStatus = "loading";
          if (
            typeof window.google === "undefined" ||
            typeof window.google.maps === "undefined"
          ) {
            var script = document.createElement("script");
            script.onload = function () {
              apiStatus = "loaded";
              initAllMaps();
            };
            script.src =
              "https://maps.googleapis.com/maps/api/js?key=" + this.key;
            document.head.appendChild(script);
          }
        }
      }
    },

    createMap: function () {
      var mapDiv = this.map;

      return geolocate(mapDiv)
        .then(
          function (results) {
            var mapOptions = {
              zoom: config.zoom,
              backgroundColor: "none",
              center: results[0].geometry.location,
              draggable: false,
              clickableIcons: false,
              scrollwheel: false,
              disableDoubleClickZoom: true,
              disableDefaultUI: true,
            };

            var map = (this.map = new google.maps.Map(mapDiv, mapOptions));
            var center = (this.center = map.getCenter());

            var marker = new google.maps.Marker({
              map: map,
              position: map.getCenter(),
            });

            google.maps.event.addDomListener(
              window,
              "resize",
              theme.utils.debounce(250, function () {
                google.maps.event.trigger(map, "resize");
                map.setCenter(center);
                mapDiv.removeAttribute("style");
              }),
            );

            if (Shopify.designMode) {
              if (window.AOS) {
                AOS.refreshHard();
              }
            }
          }.bind(this),
        )
        .catch(function (status) {
          var errorMessage;

          switch (status) {
            case "ZERO_RESULTS":
              errorMessage = errors.addressNoResults;
              break;
            case "OVER_QUERY_LIMIT":
              errorMessage = errors.addressQueryLimit;
              break;
            case "REQUEST_DENIED":
              errorMessage = errors.authError;
              break;
            default:
              errorMessage = errors.addressError;
              break;
          }

          // Show errors only to merchant in the editor.
          if (Shopify.designMode) {
            window.mapError(errorMessage);
          }
        });
    },

    onUnload: function () {
      if (this.map.length === 0) {
        return;
      }
      // Causes a harmless JS error when a section without an active map is reloaded
      if (google && google.maps && google.maps.event) {
        google.maps.event.clearListeners(this.map, "resize");
      }
    },
  });

  return Map;
})();

theme.NewsletterPopup = (function () {
  function NewsletterPopup(container) {
    this.container = container;
    var sectionId = this.container.getAttribute("data-section-id");

    this.cookieName = "newsletter-" + sectionId;
    this.cookie = Cookies.get(this.cookieName);

    if (!container) {
      return;
    }

    // Prevent popup on Shopify robot challenge page
    if (window.location.pathname === "/challenge") {
      return;
    }

    // Prevent popup on password page
    if (window.location.pathname === "/password") {
      return;
    }

    this.data = {
      secondsBeforeShow: container.dataset.delaySeconds,
      daysBeforeReappear: container.dataset.delayDays,
      hasReminder: container.dataset.hasReminder,
      testMode: container.dataset.testMode,
      isEnabled: container.dataset.enabled,
    };

    this.modal = new theme.Modals(
      "NewsletterPopup-" + sectionId,
      "newsletter-popup-modal",
    );

    // Set cookie if optional button is clicked
    var btn = container.querySelector(".popup-cta a");
    if (btn) {
      btn.addEventListener(
        "click",
        function () {
          this.closePopup(true);
        }.bind(this),
      );
    }

    // Open modal if errors or success message exist
    if (
      container.querySelector(".errors") ||
      container.querySelector(".note--success")
    ) {
      this.modal.open();
    }

    // Set cookie as opened if success message
    if (container.querySelector(".note--success")) {
      this.closePopup(true);
      return;
    }

    document.addEventListener(
      "modalClose." + container.id,
      this.closePopup.bind(this),
    );

    if (!this.cookie && this.data.isEnabled === "true") {
      this.initPopupDelay();
    }

    // Open modal if triggered by newsletter reminder
    document.addEventListener("reminder:openNewsletter", () => {
      this.modal.open();
    });
  }

  NewsletterPopup.prototype = Object.assign({}, NewsletterPopup.prototype, {
    initPopupDelay: function () {
      if (this.data.testMode === "true") {
        return;
      }
      setTimeout(
        function () {
          this.modal.open();
        }.bind(this),
        this.data.secondsBeforeShow * 1000,
      );
    },

    closePopup: function (success) {
      // Remove a cookie in case it was set in test mode
      if (this.data.testMode === "true") {
        Cookies.remove(this.cookieName, { path: "/" });
        return;
      }

      var expiry = success ? 200 : this.data.daysBeforeReappear;
      var hasReminder = this.data.hasReminder === "true";
      var newsletterAppeared =
        sessionStorage.getItem("newsletterAppeared") === "true";

      if (hasReminder && newsletterAppeared) {
        Cookies.set(this.cookieName, "opened", {
          path: "/",
          expires: expiry,
        });
      } else if (!hasReminder) {
        Cookies.set(this.cookieName, "opened", {
          path: "/",
          expires: expiry,
        });
      }
    },

    onLoad: function () {
      this.modal.open();
    },

    onSelect: function () {
      this.modal.open();
    },

    onDeselect: function () {
      this.modal.close();
    },

    onBlockSelect: function () {
      this.modal.close();
    },

    onBlockDeselect: function () {
      this.modal.open();
    },
  });

  return NewsletterPopup;
})();

theme.Recommendations = (function () {
  var selectors = {
    placeholder: ".product-recommendations-placeholder",
    sectionClass: " .product-recommendations",
    productResults: ".grid-product",
  };

  function Recommendations(container) {
    this.container = container;
    this.sectionId = container.getAttribute("data-section-id");
    this.url = container.dataset.url;

    theme.initWhenVisible({
      element: container,
      callback: this.init.bind(this),
      threshold: 500,
    });
  }

  Recommendations.prototype = Object.assign({}, Recommendations.prototype, {
    init: function () {
      var section = this.container;

      if (!section || section.dataset.enable === "false") {
        return;
      }

      var id = section.dataset.productId;
      var limit = section.dataset.limit;
      var intent = section.dataset.intent;
      var sectionId = section.dataset.sectionRenderId || "product-recommendations";

      var url =
        this.url +
        "?section_id=" +
        sectionId +
        "&limit=" +
        limit +
        "&product_id=" +
        id;

      if (intent) {
        url += "&intent=" + intent;
      }

      // When section his hidden and shown, make sure it starts empty
      if (Shopify.designMode) {
        var wrapper = section.querySelector(selectors.sectionClass);
        if (wrapper) {
          wrapper.innerHTML = "";
        }
      }

      fetch(url)
        .then(function (response) {
          return response.text();
        })
        .then(
          function (html) {
            // Convert the HTML string into a document object
            var parser = new DOMParser();
            var doc = parser.parseFromString(html, "text/html");
            var div = doc.querySelector(selectors.sectionClass);
            var placeholder = section.querySelector(selectors.placeholder);
            if (!placeholder) {
              return;
            }

            placeholder.innerHTML = "";

            if (!div) {
              this.container.classList.add("hide");
              if (AOS) {
                AOS.refreshHard();
              }
              return;
            }

            placeholder.appendChild(div);

            theme.reinitProductGridItem(section);

            document.dispatchEvent(
              new CustomEvent("recommendations:loaded", {
                detail: {
                  section: section,
                },
              }),
            );

            // If no results, hide the entire section
            var results = div.querySelectorAll(selectors.productResults);
            if (results.length === 0) {
              this.container.classList.add("hide");
            }
          }.bind(this),
        );
    },
  });

  return Recommendations;
})();

theme.StoreAvailability = (function () {
  var selectors = {
    drawerOpenBtn: ".js-drawer-open-availability",
    modalOpenBtn: ".js-modal-open-availability",
    productTitle: "[data-availability-product-title]",
  };

  function StoreAvailability(container) {
    this.container = container;
    this.baseUrl = container.dataset.baseUrl;
    this.productTitle = container.dataset.productName;
  }

  StoreAvailability.prototype = Object.assign(
    {},
    StoreAvailability.prototype,
    {
      updateContent: function (variantId) {
        var variantSectionUrl =
          this.baseUrl +
          "/variants/" +
          variantId +
          "/?section_id=store-availability";

        var self = this;

        fetch(variantSectionUrl)
          .then(function (response) {
            return response.text();
          })
          .then(function (html) {
            if (html.trim() === "") {
              this.container.innerHTML = "";
              return;
            }

            self.container.innerHTML = html;
            self.container.innerHTML =
              self.container.firstElementChild.innerHTML;

            // Setup drawer if have open button
            if (self.container.querySelector(selectors.drawerOpenBtn)) {
              self.drawer = new theme.Drawers(
                "StoreAvailabilityDrawer",
                "availability",
              );
            }

            // Setup modal if have open button
            if (self.container.querySelector(selectors.modalOpenBtn)) {
              self.modal = new theme.Modals(
                "StoreAvailabilityModal",
                "availability",
              );
            }

            var title = self.container.querySelector(selectors.productTitle);
            if (title) {
              title.textContent = self.productTitle;
            }
          });
      },
    },
  );

  return StoreAvailability;
})();

theme.BackgroundImage = (function () {
  var selectors = {
    parallaxContainer: ".parallax-container",
  };

  function backgroundImage(container) {
    this.container = container;
    if (!container) {
      return;
    }

    var sectionId = container.getAttribute("data-section-id");
    this.namespace = "." + sectionId;

    theme.initWhenVisible({
      element: this.container,
      callback: this.init.bind(this),
    });
  }

  backgroundImage.prototype = Object.assign({}, backgroundImage.prototype, {
    init: function () {
      if (this.container.dataset && this.container.dataset.parallax) {
        var parallaxContainer = this.container.querySelector(
          selectors.parallaxContainer,
        );
        var args = {
          namespace: this.namespace + "-parallax",
          desktopOnly: true,
        };

        theme.parallaxSections[this.namespace] = new theme.Parallax(
          parallaxContainer,
          args,
        );
      }
    },

    onUnload: function (evt) {
      if (!this.container) {
        return;
      }
      if (
        theme.parallaxSections[this.namespace] &&
        typeof theme.parallaxSections[this.namespace].destroy === "function"
      ) {
        theme.parallaxSections[this.namespace].destroy();
      }
      delete theme.parallaxSections[this.namespace];
    },
  });

  return backgroundImage;
})();

theme.RecentlyViewed = (function () {
  var init = false;

  function RecentlyViewed(container) {
    if (!container) {
      return;
    }

    this.container = container;
    this.sectionId = this.container.getAttribute("data-section-id");
    this.namespace = ".recently-viewed" + this.sectionId;
    this.gridItemWidth = this.container.getAttribute("data-grid-item-class");
    this.rowOf = this.container.getAttribute("data-row-of");

    theme.initWhenVisible({
      element: this.container,
      callback: this.init.bind(this),
      threshold: 600,
    });
  }

  RecentlyViewed.prototype = Object.assign({}, RecentlyViewed.prototype, {
    init: function () {
      if (init) {
        return;
      }

      init = true;

      if (
        Object.keys(theme.recentlyViewed.recent).length === 0 &&
        theme.recentlyViewed.recent.constructor === Object
      ) {
        // No previous history on page load, so bail
        this.container.classList.add("hide");
        return;
      }

      this.outputContainer = document.getElementById(
        "RecentlyViewed-" + this.sectionId,
      );
      this.handle = this.container.getAttribute("data-product-handle");

      // Request new product info via JS API
      var promises = [];
      Object.keys(theme.recentlyViewed.recent).forEach(
        function (handle) {
          if (handle !== "undefined") {
            promises.push(this.getProductInfo(handle));
          }
        }.bind(this),
      );

      Promise.all(promises).then(
        function (result) {
          this.setupOutput(result);
          this.captureProductDetails(result);
        }.bind(this),
      );
    },

    getProductInfo: function (handle) {
      return new Promise(function (resolve, reject) {
        if (theme.recentlyViewed.productInfo.hasOwnProperty(handle)) {
          resolve(theme.recentlyViewed.productInfo[handle]);
        } else {
          fetch("/products/" + handle + ".js")
            .then(function (response) {
              return response.text();
            })
            .then(function (product) {
              resolve(product);
            });
        }
      });
    },

    setupOutput: function (products) {
      var allProducts = [];
      var data = {};
      var limit = this.container.getAttribute("data-recent-count");

      var i = 0;

      Object.keys(products).forEach(
        function (key) {
          if (!products[key]) {
            return;
          }
          var product = JSON.parse(products[key]);

          // Ignore current product
          if (product.handle === this.handle) {
            return;
          }

          // Ignore undefined key
          if (typeof product.handle == "undefined") {
            return;
          }

          i++;

          // New or formatted properties
          product.url = theme.recentlyViewed.recent[product.handle]
            ? theme.recentlyViewed.recent[product.handle].url
            : product.url;
          product.image_responsive_url =
            theme.recentlyViewed.recent[product.handle].featuredImage;
          product.image_aspect_ratio =
            theme.recentlyViewed.recent[product.handle].aspectRatio;

          // Unit pricing checks first variant
          var firstVariant = product.variants[0];
          if (firstVariant && firstVariant.unit_price) {
            var baseUnit = "";

            if (firstVariant.unit_price_measurement) {
              if (firstVariant.unit_price_measurement.reference_value != 1) {
                baseUnit +=
                  firstVariant.unit_price_measurement.reference_value + " ";
              }
              baseUnit += firstVariant.unit_price_measurement.reference_unit;
            }

            product.unit_price = theme.Currency.formatMoney(
              firstVariant.unit_price,
            );
            if (baseUnit != "") {
              product.unit_price += "/" + baseUnit;
            }
          }

          allProducts.unshift(product);
        }.bind(this),
      );

      if (allProducts.length === 0) {
        this.container.classList.add("hide");
        return;
      }

      var productMarkup = theme.buildProductGridItem(
        allProducts.slice(0, limit),
        this.gridItemWidth,
        this.rowOf,
      );

      this.outputContainer.innerHTML = productMarkup;
      theme.lazyImages();

      if (AOS) {
        AOS.refreshHard();
      }
    },

    captureProductDetails: function (products) {
      for (var i = 0; i < products.length; i++) {
        var product = products[i];
        theme.recentlyViewed.productInfo[product.handle] = product;
      }

      // Add data to session storage to reduce API requests later
      if (theme.config.hasSessionStorage) {
        sessionStorage.setItem(
          "recent-products",
          JSON.stringify(theme.recentlyViewed.productInfo),
        );
      }
    },

    onUnload: function () {
      init = false;
    },
  });

  return RecentlyViewed;
})();

theme.Testimonials = (function () {
  var defaults = {
    adaptiveHeight: true,
    avoidReflow: true,
    pageDots: true,
    prevNextButtons: false,
  };

  function Testimonials(container) {
    this.container = container;
    this.timeout;
    var sectionId = container.getAttribute("data-section-id");
    this.slideshow = container.querySelector("#Testimonials-" + sectionId);
    this.namespace = ".testimonial-" + sectionId;

    if (!this.slideshow) {
      return;
    }

    theme.initWhenVisible({
      element: this.container,
      callback: this.init.bind(this),
      threshold: 600,
    });
  }

  Testimonials.prototype = Object.assign({}, Testimonials.prototype, {
    init: function () {
      // Do not wrap when only a few blocks
      if (this.slideshow.dataset.count <= 3) {
        defaults.wrapAround = false;
      }

      this.flickity = new theme.Slideshow(this.slideshow, defaults);

      // Autoscroll to next slide on load to indicate more blocks
      if (this.slideshow.dataset.count > 2) {
        this.timeout = setTimeout(
          function () {
            this.flickity.goToSlide(1);
          }.bind(this),
          1000,
        );
      }
    },

    onUnload: function () {
      if (this.flickity && typeof this.flickity.destroy === "function") {
        this.flickity.destroy();
      }
    },

    onDeselect: function () {
      if (this.flickity && typeof this.flickity.play === "function") {
        this.flickity.play();
      }
    },

    onBlockSelect: function (evt) {
      var slide = this.slideshow.querySelector(
        ".testimonials-slide--" + evt.detail.blockId,
      );
      var index = parseInt(slide.dataset.index);

      clearTimeout(this.timeout);

      if (this.flickity && typeof this.flickity.pause === "function") {
        this.flickity.goToSlide(index);
        this.flickity.pause();
      }
    },

    onBlockDeselect: function () {
      if (this.flickity && typeof this.flickity.play === "function") {
        this.flickity.play();
      }
    },
  });

  return Testimonials;
})();

